import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
import { AuthenticationService } from '../../authentication.service';

@Injectable({
  providedIn: 'root'
})

export class ComplaintsService {
  httpUrl: any

  constructor(private auth: AuthenticationService, private http: HttpClient) {
    this.httpUrl = this.auth.httpUrl;
  }


  async complauints(obj: any) {
    const resp = await this.http.post<any>(this.httpUrl + '/sdp/operator/complaint/addComplaints', obj).toPromise().then((res: any) => {
      return res;
    });

    return resp;
  }

  async uploadComplaintsDoc(obj: any) {
    const resp = await this.http.post<any>(this.httpUrl + '/sdp/operator/complaint/uploadComplaintsDoc', obj).toPromise().then((res: any) => {
      return res;
    });
    return resp;
  }


  async getComplaints(obj: any) {
    const resp = await this.http.get<any>(this.httpUrl + '/sdp/operator/complaint/getComplaints' + obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async getResolver(obj: any) {
    const resp = await this.http.get<any>(this.httpUrl + '/sdp/operator/complaint/getResolver' + obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async resolveComplaints(obj: any) {
    const resp = await this.http.post<any>(this.httpUrl + '/sdp/operator/complaint/updateComplaints' , obj).toPromise().then((res:any) => {
      return res;
    });
    return resp;
  }

 

  async viewDoc(obj: any) {
    
    const resp = await this.http.post(this.httpUrl + '/sdp/operator/complaint/viewInvoice', obj, { responseType: 'blob' }).toPromise().then(res => {
      return res;
    });

    if (resp) {
      return resp;
    }

    return
  }

}
